<template>
  <button
      v-if="show"
      class="trash-btn btn btn-warning mt-0 float-left"
      @click="startEdit"
  >
    <font-awesome-icon icon="edit" />
  </button>
</template>
<script>
import formSettings from '@/mixins/formSettings'

export default {
  props: ['id', 'show'],
  mixins: [formSettings],
  methods: {
    startEdit() {
      this.editDialogOpen = true
      this.editItemId = this.id
    },
  }
}
</script>